import type { ZeytalFigma, ZeytalTokens } from "@zeytal/types";

const findNestedNodes = (nodes: ZeytalTokens.AbstractNestedNode[]) => {
  return nodes.reduce<ZeytalTokens.LeafNode[]>((acc, node) => {
    if (Object.prototype.hasOwnProperty.call(node, "styles") && node.styles) {
      // Push only nodes with styles property
      acc.push(node as unknown as ZeytalTokens.LeafNode);
    } else if (node.children && node.children.length) {
      // Search for elements w/ children
      acc.push(...findNestedNodes(node.children));
    }
    return acc;
  }, []);
};

export const getNestedNodes = (figmaFiles: ZeytalFigma.MinimalFigmaFile[]) =>
  figmaFiles.reduce<ZeytalTokens.LeafNode[]>((acc, file) => {
    const { document } = file;

    const nestedNodes = findNestedNodes(document.children);

    return [...acc, ...nestedNodes];
  }, []);
